"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBAPIsSection", {
  enumerable: true,
  get: function get() {
    return _SVBAPIsSection.default;
  }
});
var _SVBAPIsSection = _interopRequireDefault(require("./src/SVBAPIsSection"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }